import React from "react";
import Checkbox from "apollo-react/components/Checkbox";

const CheckboxInput = ({
	field = {},
	meta = {},
	label,
	onChange,
	value,
	required,
	checked,
	style 
}) => {
    checked = checked !== undefined ? checked : field.value ?? false;
	const handleChange = (event) => {
        if (typeof onChange === 'function') {
            onChange(event.target.checked);
        }
    };

	return (
		<Checkbox
			{...field}
			label={label}
			checked={checked}
            onChange={handleChange}
			error={meta.touched && meta.error}
			required={required}
			value={value}
			helperText={meta.touched && meta.error ? meta.error : ""}
			style={style}
		/>
	);
};

export default CheckboxInput;
